import Vue from 'vue';
import { Toast } from 'vant';
import mobile from './mobile-detect.min';
import $ from 'jquery';
import wx from 'weixin-js-sdk'
import env from './env'
import VConsole from "vconsole";


console.log('env', env)

Vue.use(Toast,mobile,$,wx);

if(process.env.NODE_ENV=='testing'){
  var vConsole = new VConsole();
}

let util = {};

// 取得url单个参数
util.getQueryStr= function(name, str) {
  if(name === 'token'){
    if(window.G_CONFIG && window.G_CONFIG.token) {
      return window.G_CONFIG.token;
    }
  }
  var reg = new RegExp("(^|&|\\?)" + name + "=([^&]*)(&|$)", "i");
  var result = (str || location.search.substr(1)).match(reg);
  if (result != null) {
    var val = decodeURIComponent(result[2]);
    return val
  }
  return '';
}

// 获取统一授权地址, 应对不同场景下授权
util.getUnifiedUrl = function(){
  var UnifiedUrl ='';
  if(process.env.NODE_ENV=='testing'){  //测试环境跳转地址, 不管是 微信端还是企业微信端,都采用微信端授权
    console.warn("测试环境授权登录")
    UnifiedUrl = '/mini/login/test_uniform_platform'
  }else{
    if(env.wxwork){ // 如果企业微信
      console.warn("企业微信授权登录")
      UnifiedUrl = '/mini/login/wxwork_platform'
    }else{
      console.warn("微信授权登录")
      UnifiedUrl = '/mini/login/uniform_platform'
    }
    
  }
  return UnifiedUrl
}

// 退出
util.logout = function(){
  util.getUserId.set('');
  util.sessionid.set('');
  util.user_mobile.set('');
  util.globalData.user.set('');
  //user={}
}


util.yzxUrl = env.base_config.baseUrl;

util.ossYzxUrl = 'https://o-yzx.bysjy.com.cn/';
util.picPath = 'http://pic.bibibi.net/';
util.aliYzxPath = 'http://yun-yzx.oss-cn-shenzhen.aliyuncs.com/';
util.error_img_sm = 'http://o.bysjy.com.cn/company/98762/1564037265-8660.png';
util.token =  util.getQueryStr('token') || '';
util.train_id ='';
util.urlPrefix = '/train/h5';
util.G_CONFIG={};
util.is_gate_user = false

util.set_gate_users = function(){
  if((util.getUserId.get()!=='' && env.base_config.gate_users.indexOf(util.getUserId.get())!=-1)  || env.base_config.gate_users.indexOf('*')!=-1){
    util.is_gate_user = true
  }  
}

util.formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return [year, month, day].map(util.formatNumber).join('/') + ' ' + [hour, minute, second].map(util.formatNumber).join(':')
}
util.trim = n => {
  if(n)
    return n.replace(/^\s*|\s*$/g, "")
  else
    return ""
}

util.formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}
//复制
util.clone = n => {
  var newobj = {}
  for (var arr in n) {
    newobj[arr] = n[arr]
  }
  return newobj
}
//提示
util.showToast = n => {
  n.duration = n.duration || 2000;
  n.icon = n.icon || '';
  return Toast(n)
}

//分享的代码算法
util.share = {
  type:{
    TuiJian:'TJ',
    KeCheng:'KC'
  },
  encode: (arr)=>{
    return arr.join('@')
  },
  decode: n=>{
    return n.split('@')
  }
}

//本地缓存的用户手机
const key = util.token+"_weyon_u_user";

//用户id
const  user_id_key = util.token+"_weyon_u_user_id";

//裂变海报
const fission_poster_key = util.token+'_weyon_fission_poster';

//用户session
const user_sessionid=util.token+'_sessionid';

//用户手机号
const user_mobile_key=util.token+'_weyon_u_mobile';

//支付回调地址
const pay_redirect_url = 'pay_redirect_url';

//临时回调地址
const temp_redirect_url = 'temp_redirect_url';

//临时回调地址,防止冲突
const temp_redirect_url_sch = 'temp_redirect_url_sch';

util.payRedirect = {
  set: (n => {
    localStorage.setItem(pay_redirect_url, n)
  }),
  get: (n => {
    return localStorage.getItem(pay_redirect_url) || ""
  })
}

util.tempRedirect = {
  set: (n => {
    localStorage.setItem(temp_redirect_url, n)
  }),
  get: (n => {
    return localStorage.getItem(temp_redirect_url) || ""
  })
}

util.tempRedirectUrlSch = {
  set: (n => {
    localStorage.setItem(temp_redirect_url_sch, n)
  }),
  get: (n => {
    return localStorage.getItem(temp_redirect_url_sch) || ""
  })
}

util.storage = {
  set: (n => {
    localStorage.setItem(key, n)
  }),
  get: (n => {
    return localStorage.getItem(key) || ""
  })
}

util.getUserId={
  set: (n => {
    localStorage.setItem(user_id_key, n)
  }),
  get: (n => {
    return localStorage.getItem(user_id_key) || ""
  })
};

util.sessionid={
  set: (n => {
    localStorage.setItem(user_sessionid, n)
  }),
  get: (n => {
    return localStorage.getItem(user_sessionid) || ""
  })
};


util.fission_poster={
  set: (n => {
    localStorage.setItem(fission_poster_key, JSON.stringify(n))
  }),
  get: (n => {
    return JSON.parse(localStorage.getItem(fission_poster_key)) || ""
  })
}

util.user_mobile={
  set: (n => {
    localStorage.setItem(user_mobile_key, n)
  }),
  get: (n => {
    return localStorage.getItem(user_mobile_key) || ""
  })
}

const globalData_userInfo_key = util.token+'_globalData_userInfo';//微信的用户信息
const globalData_user_key = util.token+'_globalData_user';//登录的用户信息 -用户标识存储在 storage 里面
const globalData_share = util.token+'_globalData_share'; //打开的分享编码 一次有效,
const globalData_workEdit = util.token+'_workEdit';

util.globalData = {
  userInfo:{
    set:(n => {
      localStorage.setItem(globalData_userInfo_key, JSON.stringify(n))
    }),
    get: (n => {
      return JSON.parse(localStorage.getItem(globalData_userInfo_key)) || ""
    })
  },
  user:{
    set:(n => {
      localStorage.setItem(globalData_user_key, JSON.stringify(n))
    }),
    get: (n => {
      return JSON.parse(localStorage.getItem(globalData_user_key)) || ""
    })
  },
  share:{
    set:(n => {
      sessionStorage.setItem(globalData_share, JSON.stringify(n))
    }),
    get: (n => {
      return JSON.parse(sessionStorage.getItem(globalData_share)) || ""
    })
  },
  workEdit:{
    set:(n => {
      sessionStorage.setItem(globalData_workEdit, n)
    }),
    get: (n => {
      return sessionStorage.getItem(globalData_workEdit) || ""
    })
  }
};


/**
 * 将对象转换为url参数格式
 */
util.objToUrlParam=function(obj){
  var params = ''
  for(var p in obj){
    if(typeof (obj[p]) !== 'function'){
      params += '&' + p + '=' + obj[p];
    }
  }

  return params;
}

util.getUrl = function (module, page, params) {
  var url = '/' + module + '/' + page + '?token=' + util.getQueryStr('token');
  if (!params) {
    params = [];
  }

  if (params) {
    url = url + util.objToUrlParam(params);
  }

  location.href=util.urlPrefix+url;
}


util.isLogin = (n) => {
  if (util.sessionid.get() == '') {
    location.href= util.getUnifiedUrl()+'?token='+util.getQueryStr('token')+'&redirect='+encodeURIComponent(location.href);
    return false
  } else {
    var app = util.globalData;
    if (app.user.get() == '') {
      util.server.mini_user.info({
        callback: res => {
          app.user.set(res.data);
          util.getUserId.set(res.data.user_id);
        }
      })
    }
  }
  return true
}

//获取登录信息
util.setUserProfile = (n) => {
  if(util.sessionid.get() != ''){
    var app = util.globalData;
    if(app.user.get() == ''){
      util.server.mini_user.info({
          callback: (res => {
              util.globalData.user.set(res.data);
              util.getUserId.set(res.data.user_id);
              util.user_mobile.set(res.data.mobile);
          })
      })
    }
  }else{
    console.error("没有登录无法进行设置用户信息!!!")
  }
  return true
}

// 废弃
util.isUserLogin = function () {
  if (util.sessionid.get() == '') {
    util.getUrl('user','login',{return_url:encodeURIComponent(location.href)});
    return false
  }
  return true;
};
util.YzxAjax = n => {
  var is_show_load = true;
  var is_show_error = true;
  if(typeof n.is_show_load != 'undefined'){
    is_show_load = n.is_show_load;
  }
  if(typeof n.is_show_error != 'undefined'){
    is_show_error = n.is_show_error;
  }

  if(is_show_load) {
    Toast.loading({
      duration: 0,
      message: '加载中',
      forbidClick: true
    });
  }
  var m=n.methods || 'POST';
  n.data=n.data || {};
  n.data['token']=n.data['token'] || util.token;
  if(m == 'POST'){
    n.data = JSON.stringify(n.data);
  }
  $.ajax({
    url: util.yzxUrl + n.action + '?_t=' + Math.random(), //仅为示例，并非真实的接口地址
    data: n.data,
    type: m,
    timeout: 10000,
    dataType:'json',
    headers: {
      'content-type': 'application/json;charset=utf-8', // 默认值
      'Authorization': 'Bearer ' + (util.sessionid.get().replace(util.token+'_','')),
    },
    success: function (res) {
      if(is_show_load) {
        Toast.clear();
      }
      //认证过期提示登录
      if(res.code == util.CODE.USER_LOGIN_FAIL){
        return util.PopupLoginTips(res.msg, 1);
      }
      // 用户受限制
      if(res.code == util.CODE.USER_FORBIDDEN){
        return util.PopupForbiddenTips(res.msg, 1);
      }
      // 绑定手机
      if(res.code == util.CODE.USER_MOBILE_NONE){
        return util.GotoMobilesVerify(res.msg, 1);
      }
      if(res.code == -1 && is_show_error){
        util.showToast({
          message: res.msg,
        });
      }
      n.callback && n.callback(res);
    },
    error: function (res) {
      if(is_show_load) {
        Toast.clear();
      }
      // TODO 未初始错误状态暂时排除,有可能前端取消，影响体验
      if(res.status!=0){
        util.showToast({
          message: '网络加载失败，请重试',
        })
      }
      
    }
  })
}

util.YzxAjaxJson = n => {
  var is_show_load = true;
  if(typeof n.is_show_load != 'undefined'){
    is_show_load = n.is_show_load;
  }

  if(is_show_load) {
    Toast.loading({
      duration: 0,
      message: '加载中',
      forbidClick: true
    });
  }
  var m=n.methods || 'POST';
  n.data=n.data || {};
  var token=n.data['token'] || util.token;
  if(m == 'POST'){
    n.data = JSON.stringify(n.data);
  }
  // 如果设置is_debug 获取 测试环境允许增加调试
  var is_debug = n.is_debug || (process.env.NODE_ENV=='testing')?"&is_debug=1":''
  console.log("is_debug", is_debug);
  $.ajax({
    url: util.yzxUrl + n.action + '?_t=' + Math.random()+'&token='+ token+is_debug, //仅为示例，并非真实的接口地址
    data: n.data,
    type: m,
    timeout: 10000,
    dataType:'json',
    contentType: "application/json",
    headers: {
      'content-type': 'application/json;charset=utf-8', // 默认值
      'Authorization': 'Bearer ' + (util.sessionid.get().replace(util.token+'_','')),
    },
    success: function (res) {
      if(is_show_load) {
        Toast.clear();
      }
      //认证过期提示登录
      if(res.code == util.CODE.USER_LOGIN_FAIL){
        return util.PopupLoginTips(res.msg);
      }
      if(res.code == -1){
        util.showToast({
          message: res.msg,
        });
      }
      n.callback && n.callback(res);
    },
    error: function (res) {
      if(is_show_load) {
        Toast.clear();
      }
      util.showToast({
        message:'网络加载失败，请重试',
      })
    }
  })
}
//判断数组中是否包含某字符串
Array.prototype.contains = function(needle) {
  for (i in this) {
    if (this[i].indexOf(needle) > 0)
      return i;
  }
  return -1;
}

var device_type = navigator.userAgent; //获取userAgent信息
var md = new mobile(device_type); //初始化mobile-detect
var os = md.os(); //获取系统
var model = "";
if (os == "iOS") { //ios系统的处理
  os += ' '+md.version("iPhone");
  model = md.mobile();
} else if (os == "AndroidOS") { //Android系统的处理
  os = md.os() + md.version("Android");
  var sss = device_type.split(";");
  var i = sss.contains("Build/");
  if (i > -1) {
    model = sss[i].substring(0, sss[i].indexOf("Build/"));
  }
}

util.YzxEventAjax = n => {
  // Toast.loading({
  //   duration: 0,
  //   message: '加载中',
  //   forbidClick: true
  // });
  var m=n.methods || 'POST';
  n.data=n.data || {};
  n.data['token']=n.data['token'] || util.token;
  n.data['uid']=util.getUserId.get();
  n.data['device_info']=model +'--'+os;
  if(m == 'POST'){
    n.data = JSON.stringify(n.data);
  }
  $.ajax({
    url: util.yzxUrl + n.action + '?_t=' + Math.random(), //仅为示例，并非真实的接口地址
    data: n.data,
    type: m,
    timeout: 10000,
    dataType:'json',
    headers: {
      'content-type': 'application/json;charset=utf-8', // 默认值
      'Authorization': 'Bearer ' + (util.sessionid.get().replace(util.token+'_','')),
    },
    success: function (res) {

      // Toast.clear();

      n.callback && n.callback(res.data)
    },
    error:function (res) {
      // Toast.clear();
      // util.showToast({
      //   message: '网络加载失败，请重试3',
      // })
    }
  })
}
util.upfile = n => {
  Toast.loading({
    duration: 0,
    message: '上传中',
    forbidClick: true
  });
  var formData = new FormData();
  formData.append("file", n.file);
  $.ajax({
    url: util.yzxUrl + 'mini/user/upload?token='+util.token,
    data: formData,
    header: {
      'Authorization': 'Bearer ' + (util.sessionid.get().replace(util.token+'_','')),
      'weyon-t': 'm'
    },
    type:'POST',
    processData : false, // 使数据不做处理
    contentType : false, // 不要设置Content-Type请求头
    success: function(res) {
      Toast.clear();
      n.callback && n.callback(res)
    },
    error: (res => {
      Toast.clear();
      util.showToast({
        message: '网络加载失败，请重试',
      })
    })
  })
}
util.server = {
  user: {
    login_code: n => {
      n.action = 'users/login_code'
      return util.YzxAjax(n)
    },
  },
  yzx:{
    course_list:n => {
      n.action = 'mini/course/course_list';
      return util.YzxAjax(n)
    },
    special_detail: n => {
      n.action = 'mini/course/special_detail';
      return util.YzxAjax(n)
    },
    special_catalog: n => {
      n.action = 'mini/course/special_catalog';
      return util.YzxAjax(n)
    },
    audio_detail: n => {
      n.action = 'mini/course/audio_detail';
      return util.YzxAjax(n)
    },
    get_share_mini_url: n => {
      n.action = 'yzx/get_share_mini_url';
      return util.YzxAjax(n)
    },
    get_share_h5_url: n => {
      n.action = 'yzx/get_share_h5_url';
      return util.YzxAjax(n)
    },
    live_detail: n => {
      n.action = 'mini/course/live_detail';
      return util.YzxAjax(n)
    },
    get_poster: n => {
      n.action = 'mini/course/get_poster';
      return util.YzxAjax(n)
    },
  },
  event:{
    event:n => {
      n.action = 'event/index';
      return util.YzxEventAjax(n)
    },
  },
  mini_home:{
    index: n => {
      n.action = 'mini/v2/home/index';
      return util.YzxAjax(n)
    },
    list: n => {
      n.action = 'mini/home/list';
      return util.YzxAjax(n)
    },
    get_config: n => {
      n.action = 'mini/v1/home/get_config';
      return util.YzxAjax(n)
    },
    hot_search: n => {
      n.action = 'mini/home/hot_search';
      return util.YzxAjax(n)
    },
    search: n => {
      n.action = 'mini/home/search';
      return util.YzxAjax(n)
    },
    get_last_course: n => {
      n.action = 'mini/home/get_last_course';
      return util.YzxAjax(n)
    },
    get_tabs: n => {
      n.action = 'mini/home/tabs';
      return util.YzxAjax(n)
    },
    get_user_subscribe: n => {
      n.action = 'mini/home/get_user_subscribe';
      return util.YzxAjax(n)
    },
  },
  mini_v1_home:{
    index: n => {
      n.action = 'mini/v1/home/index';
      return util.YzxAjax(n)
    },
    list: n => {
      n.action = 'mini/v1/home/list';
      return util.YzxAjax(n)
    },
  },
  mini_user:{
    login_code: n => {
      n.action = 'mini/user/login_code';
      return util.YzxAjax(n)
    },
    login: n => {
      n.action = 'mini/user/login';
      return util.YzxAjax(n)
    },
    info: n => {
      n.action = 'mini/user/info';
      return util.YzxAjax(n)
    },
    weapp_login: n => {
      n.action = 'mini/user/weapp_login';
      return util.YzxAjax(n)
    },
    weapp_bind_phone: n => {
      n.action = 'mini/user/weapp_bind_phone';
      return util.YzxAjax(n)
    },
    bind_phone: n => {
      n.action = 'mini/user/bind_phone';
      return util.YzxAjax(n)
    },
    h5_bind_phone: n => {
      n.action = 'mini/user/h5_bind_phone';
      return util.YzxAjax(n)
    },
    save: n => {
      n.action = 'mini/user/save';
      return util.YzxAjax(n)
    },
    get_bind_users: n => {
      n.action = 'mini/user/get_bind_users';
      return util.YzxAjax(n)
    },
    check_mobile_bind: n => {
      n.action = 'mini/user/check_mobile_bind';
      return util.YzxAjax(n)
    },
    merge_users: n => {
      n.action = 'mini/user/merge_users';
      return util.YzxAjax(n)
    },
    merge_users_uniqid: n => {
      n.action = 'mini/user/merge_users_uniqid';
      return util.YzxAjax(n)
    },
  },
  mini_scores:{
    ranking: n => {
      n.action = 'mini/scores/ranking';
      return util.YzxAjax(n)
    },
  },
  mini_v1_course:{
    set_catalog: n => {
      n.action = 'mini/v1/course/set_catalog';
      return util.YzxAjax(n)
    },
  },
  mini_v2_course:{
    set_catalog: n => {
      n.action = 'mini/v2/course/set_catalog';
      return util.YzxAjax(n)
    },
  },
  mini_v1_my:{
    play_list: n => {
      n.action = 'mini/v1/my/play_list';
      return util.YzxAjax(n)
    },
  },
  mini_apply:{
    get_ddrps: n => {
      n.action = 'mini/apply/get_ddrps';
      return util.YzxAjax(n)
    },
    get: n => {
      n.action = 'mini/apply/get';
      return util.YzxAjax(n)
    },
    index: n => {
      n.action = 'mini/apply/index';
      return util.YzxAjax(n)
    },
  },
  mini_collect:{
    col_cal: n => {
      n.action = 'mini/collect/col_cal';
      return util.YzxAjax(n)
    },
  },
  mini_question:{
    test: n => {
      n.action = 'mini/question/test';
      return util.YzxAjax(n)
    },
    answer:n => {
      n.action = 'mini/question/answer';
      return util.YzxAjaxJson(n)
    },
    my_question_test:n => {
      n.action = 'mini/question/my_question_test';
      return util.YzxAjax(n)
    },
    question_test_detail:n => {
      n.action = 'mini/question/question_test_detail';
      return util.YzxAjax(n)
    },
  },
  mini_scheduling:{
    detail: n => {
      n.action = 'mini/scheduling/detail';
      return util.YzxAjax(n)
    },
    list: n => {
      n.action = 'mini/scheduling/list';
      return util.YzxAjax(n)
    },
    calendar: n => {
      n.action = 'mini/scheduling/calendar';
      return util.YzxAjax(n)
    },
    apply: n => {
      n.action = 'mini/scheduling/apply';
      return util.YzxAjax(n)
    },
  },
  mini_course:{
    images_detail: n => {
      n.action = 'mini/course/images_detail';
      return util.YzxAjax(n)
    },
    video_detail: n => {
      n.action = 'mini/course/video_detail';
      return util.YzxAjax(n)
    },
    set_catalog: n => {
      n.action = 'mini/course/set_catalog';
      return util.YzxAjax(n)
    },
    set_detail: n => {
      n.action = 'mini/course/set_detail';
      return util.YzxAjax(n)
    },
    sections_detail: n => {
      n.action = 'mini/course/sections_detail';
      return util.YzxAjax(n)
    },
    set_course_wares:n => {
      n.action = 'mini/course/set_coursewares';
      return util.YzxAjax(n)
    },
    get_course_users:n => {
      n.action = 'mini/course/get_course_users';
      return util.YzxAjax(n)
    },
    get_course_group_list:n => {
      n.action = 'mini/course/get_course_group_list';
      return util.YzxAjax(n)
    },
  },
  mini_my:{
    score_summary: n => {
      n.action = 'mini/my/score_summary';
      return util.YzxAjax(n)
    },
    direct_lists: n => {
      n.action = 'mini/my/direct_lists';
      return util.YzxAjax(n)
    },
    scores_lists: n => {
      n.action = 'mini/my/scores_lists';
      return util.YzxAjax(n)
    },
    invite_lists:n => {
      n.action = 'mini/my/invite_lists';
      return util.YzxAjax(n)
    },
    join_lists:n => {
      n.action = 'mini/my/join_lists';
      return util.YzxAjax(n)
    },
    collect_list:n => {
      n.action = 'mini/my/collect_list';
      return util.YzxAjax(n)
    },
    play_list:n => {
      n.action = 'mini/my/play_list';
      return util.YzxAjax(n)
    },
    score_fetch_config:n => {
      n.action = 'mini/my/score_fetch_config';
      return util.YzxAjax(n)
    },
  },
  mini_login:{
    index:n => {
      n.action = 'mini/login/index';
      return util.YzxAjax(n)
    }
  },
  mini_work:{
    answer_list:n => {
      n.action = 'mini/work/answer_list';
      return util.YzxAjax(n)
    },
    answer_detail:n => {
      n.action = 'mini/work/answer_detail';
      return util.YzxAjax(n)
    },
    get_busy_list:n => {
      n.action = 'mini/work/get_busy_list';
      return util.YzxAjax(n)
    },
    commit_work:n => {
      n.action = 'mini/work/commit_work';
      return util.YzxAjax(n)
    },
    reply:n => {
      n.action = 'mini/work/reply';
      return util.YzxAjax(n)
    },
    reply_list:n => {
      n.action = 'mini/work/reply_list';
      return util.YzxAjax(n)
    },
    my_work:n => {
      n.action = 'mini/work/my_work';
      return util.YzxAjax(n)
    },
    get_detail:n => {
      n.action = 'mini/work/get_detail';
      return util.YzxAjax(n)
    },
    get_works:n => {
      n.action = 'mini/work/get_works';
      return util.YzxAjax(n)
    },
    favor:n => {
      n.action = 'mini/work/favor';
      return util.YzxAjax(n)
    },
    my_answer_work:n => {
      n.action = 'mini/work/my_answer_list';
      return util.YzxAjax(n)
    },
    answer_detail:n => {
      n.action = 'mini/work/answer_detail';
      return util.YzxAjax(n)
    },
    get_all_answer_list:n => {
      n.action = 'mini/work/get_all_answer_list';
      return util.YzxAjax(n)
    },
  },
  api:{
    signature:n => {
      n.action = '/api/signature';
      return util.YzxAjax(n)
    },
    get_wx_media:n => {
      n.action = '/api/get_wx_media';
      return util.YzxAjax(n)
    },
  },
  h5_my:{
    score_fetch_config:n => {
      n.action = 'h5/my/score_fetch_config';
      return util.YzxAjax(n)
    }
  },
  mini_pay:{
    order_course:n => {
      n.action = 'mini/pay/order_course';
      return util.YzxAjax(n)
    }
  },
  mini_coupon:{
    index_coupon:n => {
      n.action = 'mini/coupon/index_coupon';
      return util.YzxAjax(n)
    },
    receive_coupon:n => {
      n.action = 'mini/coupon/receive_coupon';
      return util.YzxAjax(n)
    },
    coupon_course:n => {
      n.action = 'mini/coupon/coupon_course';
      return util.YzxAjax(n)
    },
    user_coupon:n => {
      n.action = 'mini/coupon/user_coupon';
      return util.YzxAjax(n)
    },
    course_coupon:n => {
      n.action = 'mini/coupon/course_coupon';
      return util.YzxAjax(n)
    },
    course_training:n => {
      n.action = 'mini/coupon/coupon_training';
      return util.YzxAjax(n)
    },
    detail:n => {
      n.action = 'mini/coupon/coupon_detail';
      return util.YzxAjax(n)
    },
  },
  mini_study_center:{
    user_study_info:n => {
      n.action = 'mini/study_center/user_study_info';
      return util.YzxAjax(n)
    },
    user_work_his_list:n => {
      n.action = 'mini/study_center/user_work_his_list';
      return util.YzxAjax(n)
    },
    v1_user_study_info:n => {
      n.action = 'mini/v1/study_center/user_study_info';
      return util.YzxAjax(n)
    },
  },
  mini_testing: {
    get_question: n => {
      n.action = 'mini/testing/get_question';
      return util.YzxAjax(n)
    },
    answer: n => {
      n.action = 'mini/testing/answer';
      return util.YzxAjaxJson(n)
    },
    mytesting: n => {
      n.action = 'mini/testing/my_test';
      return util.YzxAjaxJson(n)
    },
    get_course_testing: n => {
      n.action = 'mini/testing/get_course_testing';
      return util.YzxAjax(n)
    },
  },
  mini_message:{
    list:n => {
      n.action = 'mini/message/list';
      return util.YzxAjax(n)
    },
    has_home_unread:n => {
      n.action = 'mini/message/has_home_unread';
      return util.YzxAjax(n)
    },
    has_unread:n => {
      n.action = 'mini/message/has_unread';
      return util.YzxAjax(n)
    },
    read_message:n => {
      n.action = 'mini/message/read_message';
      return util.YzxAjax(n)
    },
  },
  mini_im:{
    list:n => {
      n.action = 'mini/im/list';
      return util.YzxAjax(n)
    },
  },
  mini_discus:{
    pub_reply:n => {
      n.action = 'mini/course_reply/sub_course_reply';
      return util.YzxAjax(n)
    },
    get_reply_list:n => {
      n.action = 'mini/course_reply/get_reply_list';
      return util.YzxAjax(n)
    },
    sub_reply_favor:n => {
      n.action = 'mini/course_reply/sub_reply_favor';
      return util.YzxAjax(n)
    },
    sub_reply_reply:n => {
      n.action = 'mini/course_reply/sub_reply_reply';
      return util.YzxAjax(n)
    },
    course_reply_summary:n => {
      n.action = 'mini/course_reply/course_reply_summary';
      return util.YzxAjax(n)
    },
    sub_course_favor:n => {
      //点赞
      n.action = 'mini/course_reply/sub_course_favor';
      return util.YzxAjax(n)
    },
    get_reply_detail:n => {
      //获取回复详情
      n.action = 'mini/course_reply/get_reply_detail';
      return util.YzxAjax(n)
    },
    get_reply_detail:n => {
      //获取回复详情
      n.action = 'mini/course_reply/get_reply_detail';
      return util.YzxAjax(n)
    },
    get_reply_reply_list:n => {
      //获取回复详情
      n.action = 'mini/course_reply/get_reply_reply_list';
      return util.YzxAjax(n)
    },
    fm_reply_summary:n => {
      //fm 接口
      n.action = 'mini/course_reply/fm_reply_summary';
      return util.YzxAjax(n)
    },
    sub_fm_favor:n => {
      //fm 接口
      n.action = 'mini/course_reply/sub_fm_favor';
      return util.YzxAjax(n)
    },
  },
  mini_knowledge_map:{
      get_map_list:n => {
          n.action = 'mini/knowledge_map/get_map_list';
          return util.YzxAjax(n)
      },
      search_map_list:n => {
          n.action = 'mini/knowledge_map/search_map_list';
          return util.YzxAjax(n)
      },
  },
  mini_training:{
    get_detail:n => {
        n.action = 'mini/training/detail';
        return util.YzxAjax(n)
    },
    get_stage_detail:n => {
        n.action = 'mini/training/stage_detail';
        return util.YzxAjax(n)
    },
    get_tasks:n => {
      n.action = 'mini/training/tasks';
      return util.YzxAjax(n)
    },
    get_stage_info:n => {
      n.action = 'mini/training/get_stage_info';
      return util.YzxAjax(n)
    },
    get_stage_students:n => {
      n.action = 'mini/training/get_stage_students';
      return util.YzxAjax(n)
    },
    get_training_students:n => {
      n.action = 'mini/training/get_training_students';
      return util.YzxAjax(n)
    },
    get_scores_summary:n => {
      n.action = 'mini/training/get_scores_summary';
      return util.YzxAjax(n)
    },
    get_scores_ranking:n => {
      n.action = 'mini/training/get_scores_ranking';
      return util.YzxAjax(n)
    },
    get_scores_recored:n => {
      n.action = 'mini/training/get_scores_recored';
      return util.YzxAjax(n)
    },
    get_set_detail:n => {
      n.action = 'mini/training/get_set_detail';
      return util.YzxAjax(n)
    },
    set_catalog:n => {
      n.action = 'mini/training/set_catalog';
      return util.YzxAjax(n)
    },
    get_question:n => {
      n.action = 'mini/practice/get_question';
      return util.YzxAjax(n)
    },
    answer: n => {
      n.action = 'mini/practice/answer';
      return util.YzxAjaxJson(n)
    },
    order_training:n => {
      n.action = 'mini/pay/order_training';
      return util.YzxAjax(n)
    },
    get_user_training_list:n => {
      n.action = 'mini/training/get_user_training_list';
      return util.YzxAjax(n)
    },
    live_detail:n => {
      n.action = 'mini/training/live_detail';
      return util.YzxAjax(n)
    },
    sections_detail:n => {
      n.action = 'mini/training/sections_detail';
      return util.YzxAjax(n)
    },
  },
  mini_minivedio:{
    index:n => {
        n.action = 'mini/minivedio/index';
        return util.YzxAjax(n)
    },
    favor:n => {
      n.action = 'mini/minivedio/favor';
      return util.YzxAjax(n)
    },
    reply_list:n => {
      n.action = 'mini/minivedio/reply_list';
      return util.YzxAjax(n)
    },
    reply:n => {
      n.action = 'mini/minivedio/reply';
      return util.YzxAjax(n)
    },
    reply_reply:n => {
      n.action = 'mini/minivedio/reply_reply';
      return util.YzxAjax(n)
    },
    child_reply_list:n => {
      n.action = 'mini/minivedio/child_reply_list';
      return util.YzxAjax(n)
    },
    favor_reply:n => {
      n.action = 'mini/minivedio/favor_reply';
      return util.YzxAjax(n)
    },
    content:n => {
      n.action = 'mini/minivedio/content';
      return util.YzxAjax(n)
    },
    group_list:n => {
      n.action = 'mini/minivedio/group_list';
      return util.YzxAjax(n)
    },
    
  },
  mini_evaluation:{
    has_yjy_login:n => {
      n.action = 'mini/evaluation/has_yjy_login';
      return util.YzxAjax(n)
    },
    yjy_login:n => {
      n.action = 'mini/evaluation/yjy_login';
      return util.YzxAjax(n)
    },
    has_evaluation_history:n => {
      n.action = 'mini/evaluation/has_evaluation_history';
      return util.YzxAjax(n)
    },
    get_evaluation:n => {
      n.action = 'mini/evaluation/get_evaluation';
      return util.YzxAjax(n)
    },
    get_recommend:n => {
      n.action = 'mini/evaluation/get_recommend';
      return util.YzxAjax(n)
    },
    test_evaluation:n => {
      n.action = 'mini/evaluation/test_evaluation';
      return util.YzxAjax(n)
    },
    auth_code:n => {
      n.action = 'mini/yjy_sso/login/auth2_login';
      return util.YzxAjax(n)
    },
  },
  mini_test:{
    moni_login:n => {
      n.action = 'mini/test/moni_login';
      return util.YzxAjax(n)
    }
  }
};

//配置信息
$.ajax({
  url:util.yzxUrl+'mini/v1/home/get_config?token='+util.token,
  type:'get',
  async:false,
  success:function (res) {
    util.G_CONFIG = res.data;
  }
});


// 微信事件、方法处理
util.jweixin = function (fn) {
  util.getSignPackage(function (sign) {
    util.bindWX(sign, function (wx) {
      fn(wx);
    })
  });
};
//微信SDK调用
util.getSignPackage = function(callback){
  util.server.api.signature({
    data:{
      url:location.href
    },
    is_show_load:false,
    callback:function (res) {
      if(res.code == -1){
        util.showToast({
          message:res.msg
        })
      }

      callback(res.data);
    }
  })
};
util.bindWX = function (sign, fn) {
  wx.config({
      appId: sign.appId,
      timestamp: sign.timestamp,
      nonceStr: sign.nonceStr,
      signature: sign.signature,
      jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'hideMenuItems',
          'showMenuItems',
          'chooseImage',
          'previewImage',
          'uploadImage',
          'downloadImage',
          'getLocation',
          'hideOptionMenu',
          'startRecord',
          'stopRecord',
          'onVoiceRecordEnd',
          'playVoice',
          'pauseVoice',
          'stopVoice',
          'onVoicePlayEnd',
          'uploadVoice',
          'downloadVoice'
      ],
      openTagList: ['wx-open-audio','wx-open-subscribe'] 
  });

  wx.ready(function () {
    wx.checkJsApi({
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'hideMenuItems',
        'showMenuItems',
        'chooseImage',
        'previewImage',
        'uploadImage',
        'downloadImage',
        'getLocation',
        'hideOptionMenu',
        'startRecord',
        'stopRecord',
        'onVoiceRecordEnd',
        'playVoice',
        'pauseVoice',
        'stopVoice',
        'onVoicePlayEnd',
        'uploadVoice',
        'downloadVoice'
      ],
      success: function (res) {
        //如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        if (res.errMsg == "checkJsApi:ok") {
          if (!!fn) {
            fn(wx);
          }
        }
        else {
          util.showToast({
            message:'您当前的微信版本过低'
          });
        }
      }
    });
  });
};
util.wxShare = function (wx, share) {
  // 监听“分享给朋友”
  wx.onMenuShareAppMessage({
    title: share.title,
    desc: share.desc,
    link: share.link,
    imgUrl: share.imgUrl
  });

  //监听“分享到朋友圈”
  wx.onMenuShareTimeline({
    title: share.title,
    link: share.link,
    imgUrl: share.imgUrl
  });

  //监听“分享到QQ”
  wx.onMenuShareQQ({
    title: share.title,
    desc: share.desc?share.desc:share.title,
    link: share.link,
    imgUrl: share.imgUrl,
    fail: function (res) {
      alert('分享到QQ失败'+JSON.stringify(res));
      //console.log(JSON.stringify(res) +'onMenuShareQQ');
    }
  });

  //监听“分享到微博”
  wx.onMenuShareWeibo({
    title: share.title,
    desc: share.desc,
    link: share.link,
    imgUrl: share.imgUrl
  });
};
//禁止当前页面分享
util.hideOptionMenu = function(){
  util.getSignPackage(function (sign) {
    util.bindWX(sign, function (wx) {
      wx.hideOptionMenu();
    })
  });

};

util.tansPics = function (array, col, params) {
  if (col) {
    let cols = col.indexOf('.') > -1 ? col.split('.') : [col]
    if (Array.isArray(array)) {
      for (let index in array) {
        getValue(array[index], cols, params)
      }
    } else {
      getValue(array, cols, params)
    }
  }
};

const getValue = (obj, cols, params) => {
  if (Object.prototype.toString.call(obj) === '[object Object]') {
    var url = '';
    (function getKeysFn(o, _index) {
      if (cols[_index]) {
        var key = cols[_index]
        if (Object.prototype.toString.call(o[key]) === '[object Object]') {
          getKeysFn(o[key], _index + 1)
        } else {
          url = o[key]
          if (!url || url.indexOf('http') < 0) {
            url = params.default_img || util.error_img_sm
          } else if (url.indexOf('https') < 0) {
            url = url.replace(util.aliYzxPath, util.ossYzxUrl).replace(util.picPath, util.ossYzxUrl)
          }
          if (url.indexOf('x-oss-process') < 0) {
            if (params.style) {
              url += ('?x-oss-process=style/' + params.style)
            } else if (params.resize) {
              url += ('?x-oss-process=image/resize,m_fill,' + params.resize)
            }
          }
          o[key] = url
        }
      }
    })(obj, 0)
  }
};
util.compareVersion = function (v1, v2) {
  v1 = v1.split('.')
  v2 = v2.split('.')
  const len = Math.max(v1.length, v2.length)

  while (v1.length < len) {
    v1.push('0')
  }
  while (v2.length < len) {
    v2.push('0')
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i])
    const num2 = parseInt(v2[i])

    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }

  return 0
};

//转发公共方法
util.shareAppMessage = function(title,path,imageUrl){
  return {
    title: title,
    path: path,
    imageUrl: imageUrl
  };
};
/*获取当前页url*/
util.getCurrentPageUrl = function (){
  return window.location.host+window.location.pathname //当前页面url
};

/*获取当前页带参数的url*/
util.getCurrentPageUrlWithArgs=function (){
  return window.location.href
};


/*
 *创建缓存
 * @param e 缓存名称
 * @param t 缓存值
 * @param i 缓存时间
 */
util.setCache=function(e, t, i) {
  var n = +new Date / 1000,
      a = true,
      o = {
        expire: i ? n + parseInt(i) : 0,
        value: t
      };
  try {
    localStorage.setItem(e, o)
  } catch (e) {
    a = false
  }
  return a
};
/*
 *获取缓存
 * @param e 缓存名称
 * @param t 缓存值
 */
util.getCache=function(e, t){
  var i = +new Date / 1000,
      n = "";
  i = parseInt(i);
  try {
    n = localStorage.getItem(e), n.expire > i || 0 == n.expire ? n = n.value : (n = "",util.removeCache(e))
  } catch (e) {
    n = void 0 === t ? "" : t
  }
  return n = n || ""
};
/*
 *清除缓存
 * @param e 缓存名称
 */
util.removeCache=function(e) {
  var t = true;
  try {
    localStorage.removeItem(e)
  } catch (e) {
    t = false
  }
  return t
};

//生成随机数
//n => 多少位
const charts = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
util.random = function generateMixed(n){
  var res = '';
  for(var i = 0; i <n; i++){
    var id = Math.ceil(Math.random()*35);
    res += charts[id];
  }
  return res;
};

util.carouselUrl = function (url) {
  if (!url || typeof url !== 'string') {
    return
  }
  // 判断是外链还是内链接
  if (/^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/.test(url)) {
    window.location.href=url;
  } else if (/^(pages)/.test(url)) {
    if(url.indexOf('?')>-1){
      location.href = util.urlPrefix + '/'+url.replace('pages','')+'&token='+util.token
    }else{
      location.href = util.urlPrefix + '/'+url.replace('pages','')+'?token='+util.token
    }

  }
};

//根据类型返回H5地址， TODO首页地方
util.getMiniCourseTypeUrl=function(type,id){
  var link='';
  switch (parseInt(type)) {
    case 1:
      link ='/music_detail/index?course_id=' + id;
      break;
    case 2:
      link ='/live/index?course_id=' + id;
      break;
    case 3:
      link='/video_detail/index?course_id=' + id;
      break;
    case 4:
      link='/course_music/index?course_id=' + id;
      break;
    case 5:
      link='/image_text_detail/index?course_id=' + id;
      break;
    case 6:
      link='/curriculum/index?course_id=' + id;
      break;
    case 7://课表
      link='/time_table_detail/index?scheduling_id=' + id;
      break;
    case 11://训练营
      link='/training/index?training_id=' + id;
      break;
    case 12://小视频
      link='/micro/single?minivideo_id=' + id;
      break;
  }
  return util.urlPrefix + link + '&token='+util.token;
};
util.CODE ={
  USER_LOGIN_FAIL:200001,
  USER_FORBIDDEN:200002,
  USER_MOBILE_NONE:200003,
  COLLECTION_CODE:{
    0:'取消收藏',
    1:'收藏成功'
  },
};

//弹窗登录提示
var is_show_login_tips=true;
util.PopupLoginTips=function(msg,time){

  // TODO 解决多次刷新code问题 , 是否在登录当中, 如果登录当中直接返回false,
  if(localStorage.getItem('is_loging')==1){
    return false
  }
  localStorage.setItem('login_tag', 1)

  var times = time || 1500;
  if(!is_show_login_tips){
    return;
  }
  is_show_login_tips=false;

  util.showToast({
    message: '正在登录中',
  });

  setTimeout(function () {
    localStorage.setItem('login_tag',0)
    is_show_login_tips=true;

    location.href= util.getUnifiedUrl()+'?token='+util.getQueryStr('token')+'&redirect='+encodeURIComponent(location.href);

  },times)
};

util.PopupForbiddenTips=function(msg,time){
  var times = time || 1500;
  setTimeout(function () {
    location.href= util.urlPrefix+'/errors/audit?token='+util.getQueryStr('token');
  },times)
};

util.GotoMobilesVerify=function(msg,time){
  var times = time || 1500;
  util.tempRedirect.set(location.href)
  setTimeout(function () {
    //location.href= util.urlPrefix+'/user/mobile?token='+util.getQueryStr('token');

    util.getUrl('user','mobile');
  },times)
};

//根据不同课程类型 跳转不同地址 TODO 除其他首页地方
util.gotoCurriculumDetailUrl=function(type,id,p_id){

  var link='';
  switch (parseInt(type)) {
    case 1:
      link ='/music_detail/index?course_id=' + id+(p_id && !!p_id?'&p_id='+p_id:'');
      break;
    case 2:
      link ='/live/index?course_id=' + id+(p_id && !!p_id?'&p_id='+p_id:'');
      break;
    case 3:
      link='/video_detail/index?course_id=' + id+(p_id && !!p_id?'&p_id='+p_id:'');
      break;
    case 4:
      link='/course_music/index?course_id=' + id;
      break;
    case 5:
      link='/image_text_detail/index?course_id=' + id+(p_id && !!p_id?'&p_id='+p_id:'');
      break;
    case 6:
      link='/curriculum/index?course_id=' + id+(p_id && !!p_id?'&p_id='+p_id:'');
      break;
    case 7://课表
      link='/time_table_detail/index?scheduling_id=' + id;
      break;
    case 11://训练营
      link='/training/index?training_id=' + id;
      break;
  }

  return util.urlPrefix + link+'&token='+util.token;

};

util.getTime=function(value,format){
  let result = parseInt(value);
  let formats = format ||  'm:s';
  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
  if(formats == 'h:m:s'){
    result = `${h}:${m}:${s}`;
  }
  if(formats == 'h:m'){
    result = `${h}:${m}`;
  }
  if(formats == 'm:s'){
    result = `${m}:${s}`;
  }
  return result
};

//时间转时分秒
util.timeToSec = function(time){
  var times = 0;
  var arr = time.split(':');

  if(arr[2]){
    if(arr[0]){
      times = times + arr[0]*3600;
    }
    if(arr[1]){
      times = times + arr[1]*60;
    }
    if(arr[2]){
      times = times + arr[2]*1;
    }
  }else if(arr[1]){
    if(arr[0]){
      times = times + arr[0]*60;
    }
    if(arr[1]){
      times = times + arr[1]*1;
    }
  }else{
    if(arr[0]){
      times = times + arr[0]*1;
    }
  }

  return times*1;


};

util.base64Img2Blob=function(code) {
  var parts = code.split(';base64,');
  var contentType = parts[0].split(':')[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;
  var uInt8Array = new Uint8Array(rawLength);
  for(var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], {
    type: contentType
  });
};
util.currentTime = function (format) {
  var formats = format || '';

  var myDate = new Date();

  var year=myDate.getFullYear();        //获取当前年
  var month=myDate.getMonth()+1;   //获取当前月
  var date=myDate.getDate();            //获取当前日


  var h=myDate.getHours();              //获取当前小时数(0-23)
  var m=myDate.getMinutes();          //获取当前分钟数(0-59)
  var s=myDate.getSeconds();

  return year+formats+getNow(month)+formats+getNow(date)+getNow(h)+getNow(m)+getNow(s);
};
//判断是否在前面加0
function getNow(s) {
  return s < 10 ? '0' + s: s;
}

util.hilight_word=function (key, word) {
  let idx = word.indexOf(key), t = [];

  if (idx > -1) {
    if (idx == 0) {
      t =util.hilight_word(key, word.substr(key.length));
      t.unshift({ key: true, str: key });
      return t;
    }

    if (idx > 0) {
      t =util.hilight_word(key, word.substr(idx));
      t.unshift({ key: false, str: word.substring(0, idx) });
      return t;
    }
  }
  return [{ key: false, str: word }];
};
export {
  util
};
